<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const currentEducationLevelOptions = [
        `Terminale`,
        `Bac obtenu`,
        `Bac+1`,
        `Bac+2 (BTS / DUT)`,
        `Bac+3 ou plus`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const studyDomainsOptions = [
        `Management, Gestion & Ressources humaines`,
        `Marketing, Communication & Digital`,
        `Finance, Comptabilité & Audit`,
        `Commerce & Relations internationales`,
        `Droit & Sciences politiques`,
        `Sciences humaines, Philosophie & Théologie`,
        `Informatique & Nouvelles technologies`,
        `Logistique, Transport & Supply Chain`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const formationTypeOptions = [
        `Licence / Bachelor (Bac +3)`,
        `Master (Bac +5)`,
        `BTS / DUT (Bac +2)`,
        `Formation qualifiante (courte durée)`,
        `Formation continue (professionnels)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const startDateOptions = [
        `Prochaine rentrée universitaire`,
        `Dans 6 mois`,
        `Plus tard`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.enseignementSuperieur.currentEducationLevel}
        class=""
        let:field
        let:id
        label={`Niveau d'études actuel`}
        required={false}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={currentEducationLevelOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.enseignementSuperieur.studyDomains}
        class=""
        let:field
        let:id
        label={`Dans quel domaine souhaitez-vous poursuivre vos études ?`}
        required={false}
        helpLabel="Plusieurs choix possibles (max 3)"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={3}
            defaultClass="grid grid-cols-1 @[450px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={studyDomainsOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.enseignementSuperieur.formationType}
        class=""
        let:field
        let:id
        label={`Quel type de formation recherchez-vous ?`}
        required={false}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={formationTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.enseignementSuperieur.startDate}
        class=""
        let:field
        let:id
        label={`Quand souhaitez-vous commencer votre formation ?`}
        required={false}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[250px]:grid-cols-2 @[350px]:grid-cols-3 gap-x-6 gap-y-0"
            choices={startDateOptions}
        />
    </Row>

    <Row {form} field={fields.message} label={'Votre demande'} required let:field>
        <p>Précisez votre besoin, soyez le plus précis dans votre demande</p>

        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
